import { isObject } from 'lodash'

export const parseErrorResponse = error => {
  if (!error) return null

  const { data } = error

  if (!data?.errors) return data

  if (Array.isArray(data.errors)) return data.errors[0]
  else return data.errors?.value ? data.errors.value[0] : data.errors
}

export const parseErrorResponseMessage = error => {
  if (!error) return null
  const { data } = error

  if (data?.message) return data.message

  if (!data?.errors) return data

  if (Array.isArray(data.errors)) {
    return data.errors.reduce((message, error) => message + `${reduceObjectToMessage(error)} \n`, 'Error : ')
  }

  if (isObject(data.errors)) { return reduceObjectToMessage(data.errors) }

  return data.message
}

const reduceObjectToMessage = obj => Object.keys(obj).reduce((message, key) => message + `${key} ${obj[key]}\n`, '')
